import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';
import { HomeFacade } from '../../../facades/home.facade';
import { PropertySearchCardVM } from '../../../models/property-search-card.vm';

/** Hero del home: slider de últimas propiedades + CTAs + dialog del buscador. */
@Component({
    selector: 'app-section-start',
    templateUrl: './section-start.component.html',
    styleUrls: ['./section-start.component.scss'],
})
export class SectionStartComponent implements OnInit, OnDestroy {
    isSearchDialogVisible = false;
    observer!: IntersectionObserver;

    @ViewChild('sliderSection', { static: true }) sliderSection!: ElementRef;

    /** Slider infinito: duplica las últimas propiedades (misma fuente que el carrusel). */
    readonly loopedProperties$: Observable<PropertySearchCardVM[]> = this.home.latest$.pipe(
        map((list) => [...list, ...list]),
    );

    constructor(readonly home: HomeFacade, public authService: AuthService) {}

    ngOnInit(): void {
        this.home.loadLatest();
        this.setupVisibilityObserver();
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }

    private setupVisibilityObserver(): void {
        this.observer = new IntersectionObserver(([entry]) => {
            const slider = this.sliderSection.nativeElement.querySelector('.slider');
            if (slider) {
                slider.classList.toggle('scroll-active', entry.isIntersecting);
            }
        }, { threshold: 0.1 });
        this.observer.observe(this.sliderSection.nativeElement);
    }

    toggleDialog(value: boolean): void {
        this.isSearchDialogVisible = value;
    }

    handleDialogClose(value: boolean): void {
        this.isSearchDialogVisible = value;
    }

    get isUserLoggedIn(): boolean {
        return this.authService.isLoggedIn();
    }
}
